import { render, staticRenderFns } from "./TwoFactorModal.vue?vue&type=template&id=45f1182a&"
import script from "./TwoFactorModal.vue?vue&type=script&lang=js&"
export * from "./TwoFactorModal.vue?vue&type=script&lang=js&"
import style0 from "./TwoFactorModal.vue?vue&type=style&index=0&id=45f1182a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports